import { sortBy } from '@paragon/utilities';

import {
  GlobalListenerEvent,
  GlobalListenerEventWithOrder,
  GlobalThreeJSDomObjectEvent,
  ObjectListenerEvent,
  ThreeJSDomEventType,
} from './types';

/**
 * Provides a mechanism for registering and dispatching event listeners for global events.
 * Extracted from and intended only for use by `ThreeJsDom`.
 */
export class ThreeJsDomEventTarget {
  private readonly globalCallBacks: { [eventType: string]: GlobalListenerEventWithOrder[] };

  // FIXME: it would be cleaner to make these private and expose dispatching functions for use by ThreeJSDom
  protected readonly callBacks: { [uuid: string]: { [eventType: string]: ObjectListenerEvent[] } } = {};

  constructor() {
    this.globalCallBacks = {
      click: [],
      mousemove: [],
      mousedown: [],
      mouseup: [],
      contextmenu: [],
      mouseover: [],
      mouseout: [],
      touchmove: [],
      touchstart: [],
      touchend: [],
      touchpinch: [],
      wheel: [],
      mouseleave: [],
    };
  }

  private sortEventOrder = (eventsWithOrders: GlobalListenerEventWithOrder[]) =>
    sortBy(eventsWithOrders, (eventWithOrder) => eventWithOrder.eventOrder, 'desc');

  public addGlobalListener(eventType: ThreeJSDomEventType, callBack: GlobalListenerEvent, eventOrder = 0) {
    this.globalCallBacks[eventType].push({ callBack, eventOrder });
    this.globalCallBacks[eventType] = this.sortEventOrder(this.globalCallBacks[eventType]);
  }

  public removeGlobalListener(eventType: ThreeJSDomEventType, callback: GlobalListenerEvent) {
    const callbackIndex = this.globalCallBacks[eventType].findIndex(
      (eventWithOrder) => eventWithOrder.callBack === callback,
    );
    if (callbackIndex === -1) {
      console.warn(`While removing global listener, callback for ${eventType} was not found.`);
      return;
    }
    this.globalCallBacks[eventType].splice(callbackIndex, 1);
    this.globalCallBacks[eventType] = this.sortEventOrder(this.globalCallBacks[eventType]);
  }

  protected dispatchGlobalEvent(event: GlobalThreeJSDomObjectEvent): false | void {
    for (const handler of this.globalCallBacks[event.eventType]) {
      const result = handler.callBack(event);
      if (result === false) {
        return false;
      }
    }
  }
}
